import { render, staticRenderFns } from "./TopVideosCard.vue?vue&type=template&id=7a551436"
import script from "./TopVideosCard.vue?vue&type=script&lang=js"
export * from "./TopVideosCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports